import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getAdminOnePurchaseOrder = createAsyncThunk(
    "/admin/get-one-admin-po",
    async (id, { rejectWithValue }) => {
        try {
            const myurl = `${V_URL}/believe/get-one-po/${id}`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
                },
            });

            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                toast.error(data.message || "Failed to fetch Purchase Order");
                return rejectWithValue(data);
            }
        } catch (error) {
            const message = error.response?.data?.message || error.message || "Something went wrong";
            toast.error(message);
            return rejectWithValue(error.response?.data || message);
        }
    }
);

const getAdminOnePurchaseOrderSlice = createSlice({
    name: "getAdminOnePurchaseOrder",
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {
        resetGetAdminOnePo: (state) => {
            state.data = null;
            state.loading = false;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminOnePurchaseOrder.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAdminOnePurchaseOrder.fulfilled, (state, action) => {
                state.data = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getAdminOnePurchaseOrder.rejected, (state, action) => {
                state.data = null;
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { resetGetAdminOnePo } = getAdminOnePurchaseOrderSlice.actions;
export default getAdminOnePurchaseOrderSlice.reducer;
